import React from "react";
import { Link, useRouteMatch } from "react-router-dom";

import Icon from "@ant-design/icons";
import { Card, Typography, Space, Menu } from "antd";

import { StyledMenuItem } from "./styles";

import { useServicesContext } from "components/ratecard/contextProviders";
import { useOrganizationContext } from "contextProviders/organization/OrganizationProvider";
import FulfillmentBackButton from "pages/fulfillment/FulfillmentBackButton";

import * as Icons from "../Icons";

const getIcon = (): Record<string, React.FunctionComponent<React.SVGProps<SVGSVGElement>>> => ({
  warehousing: Icons.WarehouseIcon,
  pickPack: Icons.PeekAndPackIcon,
  supplies: Icons.SuppliesIcon,
});

const RateCardHeader: React.FC = () => {
  const { path, url } = useRouteMatch();
  const { data: organization } = useOrganizationContext();
  const { services } = useServicesContext();

  const pathName = path.replace(":organization_id", organization?.id || "");

  return (
    <Card>
      <Space direction="vertical" size={25}>
        <FulfillmentBackButton urlPath={pathName.replace("/rate-card", "")} label="Back to organization details" />
        <Typography.Title>{organization?.name} Rate Card</Typography.Title>
      </Space>
      <Menu selectedKeys={[window.location.pathname]} mode="horizontal">
        {false && (
          <StyledMenuItem key={pathName}>
            <Link to={`${url}`}>
              <Icon component={Icons.BillingFrequencyIcon} />
              Billing Frequency
            </Link>
          </StyledMenuItem>
        )}
        <StyledMenuItem key={`${pathName}/nsSettings`}>
          <Link to={`${url}/nsSettings`}>
            <Icon component={Icons.SettingsIcon} size={20} />
            Settings
          </Link>
        </StyledMenuItem>

        {services?.map((service) => {
          return (
            <StyledMenuItem key={`${pathName}/${service.id}`}>
              <Link to={`${url}/${service.id}`}>
                <Icon component={getIcon()[service.slug]} size={20} />
                {service.name}
              </Link>
            </StyledMenuItem>
          );
        })}
      </Menu>
    </Card>
  );
};

export default RateCardHeader;
